<template>
  <div>
    <b-modal :ref="ref" :title="modalTitle" @close="handleClose" :no-close-on-backdrop="true" hide-footer>
      <b-form @submit.prevent="handleSubmit">
        <b-row v-for="(contract, i) in contracts" :key="i">
          <b-col>
            <label :for="`contract__nr-${i}`">Contract number</label>
            <input
                :id="`contract__nr-${i}`"
                :class="{ required: !contract.contract_nr }"
                placeholder=""
                v-model="contract.contract_nr"
                class="form-control"
                disabled
                type="text" />
          </b-col>
          <b-col>
            <label :for="`contract__sums-${i}`">Invoice sum</label>
            <input
                :id="`contract__sums-${i}`"
                v-digits-after-decimal="{numberOfDigits: 2}"
                :class="{ required: !contract.invoice_sums }"
                placeholder=""
                v-model="contract.invoice_sums"
                class="form-control"
                type="text" />
          </b-col>
          <b-col>
            <label :for="`invoice_number-${i}`">Invoice number</label>
            <input
                :id="`invoice_number-${i}`"
                :class="{ required: !contract.invoice_number }"
                placeholder=""
                v-model="contract.invoice_number"
                class="form-control"
                type="text" />
          </b-col>
          <b-col cols="4">
            <label>{{$t('labels.invoices.invoice_date')}}</label>
            <datepicker v-model="contract.invoice_date" lang="en"
                        placeholder=""
                        :class="{ required: (!contract.invoice_date)}"
                        :first-day-of-week="1"
            ></datepicker>
          </b-col>
        </b-row>
        <hr class="contracts-and-sums__hr">
        <div slot="modal-footer" class="w-100 text-right">
          <b-btn size="sm" variant="success" type="submit">
            {{ $t('buttons.common.save') }}
          </b-btn>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker'
import moment from 'moment'
import { DATE_FORMAT } from '@/constants'
import FloatInput from '@/components/common/FloatInput'

export default {
  name: 'ContractsAndSumsModal',
  components: { FloatInput, Datepicker },
  data () {
    return {
      ref: 'contractsAndSumsModal',
      contracts: []
    }
  },
  methods: {
    hide () {
      this.$refs[this.ref].hide()
      this.$emit('onHide')
    },
    async handleClose () {
      this.hide()
    },
    async handleSubmit () {
      try {
        const { contracts } = this
        await this.$http.put('accounting/purchase_invoices/create_by_operation/', {
          contracts: contracts.map((contract) => {
            contract.invoice_sums = Number(contract.invoice_sums).toFixed(2)
            contract.invoice_date = moment(contract.invoice_date).format(DATE_FORMAT)
            return contract
          })
        })
      } catch (e) {
        console.log(e)
      }
      this.hide()
    },
    async openModal () {
      const { id } = this.$route.params
      const { data } = await this.$http.get(`woodware/movements/${id}/contracts_and_sums/`)
      this.contracts = data
      if (data.length) {
        this.$refs[this.ref].show()
      } else {
        this.hide()
      }
    }
  },
  computed: {
    modalTitle () {
      return `${this.$i18n.t('modal_dialogs.contracts.purchase_invoices_sums')}`
    }
  },
  mounted () {
    this.$root.$on('openContractsAndSumsModal', async () => {
      if (this.$refs[this.ref]) {
        await this.openModal()
      }
    })
  },
  beforeDestroy () {
    this.$root.$off('openContractsAndSumsModal')
  }
}
</script>

<style lang="sass">
.contracts-and-sums__hr
  margin: 20px -16px
</style>


// WEBPACK FOOTER //
// src/components/modals/ContractsAndSumsModal.vue